import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Eyebrow } from "./Reveal";
import { FAQS } from "../data";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32" style={{ background: "var(--bone)" }}>
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="mb-14">
          <Eyebrow>FAQ</Eyebrow>
          <h2 className="font-display font-extrabold uppercase tracking-tight text-4xl sm:text-5xl leading-[0.95]"
              style={{ color: "var(--pine)" }}>
            Frequently asked <span className="font-serif-a italic normal-case font-medium" style={{ color: "var(--brass)" }}>questions</span>
          </h2>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`}
                           style={{ borderColor: "rgba(0,0,0,0.1)" }}>
              <AccordionTrigger className="text-left font-display font-bold uppercase tracking-tight text-base hover:no-underline"
                                style={{ color: "var(--pine)" }}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed" style={{ color: "#4a4a4a" }}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
